import { useQuery } from 'react-query'

import { DataApi, QUERY_KEYS } from '@api'
import { BulkHistoryDataFilters } from '@types'

const useGetBulkDataHistory = (filters?: BulkHistoryDataFilters) => {
  const { data, isLoading } = useQuery([QUERY_KEYS.UPLOAD_BULK_DATA_HISTORY, { filters }], () =>
    DataApi.getBulkDataHistory({ filters }),
  )
  return {
    bulkDataHistory: data?.sapTptImportHistory?.routes,
    bulkDataHistoryTotal: data?.sapTptImportHistory?.total,
    isLoading,
  }
}

export { useGetBulkDataHistory }
